import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUser, faInfo, faInfoCircle, faChevronRight, faShoppingCart, faExclamationTriangle, faCheckCircle,
  faTimesCircle, faSignOutAlt, faSignInAlt, faCog, faCaretDown, faCaretUp, faTrash, faEdit, faPlus, faSpinner,
  faSave, faBan, faArrowsAlt, faBars
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faUser, faInfo, faInfoCircle, faChevronRight, faShoppingCart, faExclamationTriangle, faCheckCircle,
  faTimesCircle, faSignOutAlt, faSignInAlt, faCog, faCaretDown, faCaretUp, faTrash, faEdit, faPlus, faSpinner,
  faSave, faBan, faArrowsAlt, faBars
);

Vue.component('fa', FontAwesomeIcon);